module.exports = __webpack_public_path__ + "img/morris-pro.27c91d95.jpg";